import apiClient from './api'
import type { SubscriptionData } from '../stores/subscriptionStore'

/**
 * Fetch customer subscription data
 * @param customerId - The customer ID to fetch subscriptions for
 * @returns Promise with subscription data
 */
export const getCustomerSubscription = async (
  customerId: string
): Promise<SubscriptionData> => {
  try {
    const response = await apiClient.get<SubscriptionData>(
      `/my-subscription`
    )
    return response.data
  } catch (error) {
    console.error('Failed to fetch customer subscription:', error)
    throw error
  }
}

/**
 * Fetch current user's subscription data
 * This should be called after authentication to get the user's subscriptions
 */
export const getCurrentUserSubscription = async (): Promise<SubscriptionData> => {
  try {
    // Replace with your actual endpoint for current user subscriptions
    // Assuming you have an endpoint like /user/subscription or /me/subscription
    const response = await apiClient.get<SubscriptionData>('/my-subscription')
    return response.data
  } catch (error) {
    console.error('Failed to fetch user subscription:', error)
    throw error
  }
}
